export default __webpack_public_path__ + "static/media/YAS0080.34I-29704_-17147_0.35c9d067.jpg";